import React from 'react';
import withSensitiveImage from '../../Containers/withSensitiveImage';
import withSrcSets from '../../Containers/withSrcSets';
import ImageBlock from '../../ImageBlock';
import MediaGalleryContent from './content';

const MediaGalleryImage = (props) => {
  const {
    activeIndex,
    index,
    pageProps,
    counter,
    numberOfItems,
    ImageHeading,
    ImageText,
    ImageLinks,
    isStanding,
    slideWidth,
    showAuthor,
    translations,
    isArticlePage,
    isMobile,
    alwaysShowCurrentImage,
  } = props;
  const ImageBlockWithSrcSets = withSrcSets(withSensitiveImage(ImageBlock));

  const forciblyShowCurrentCount =
    (alwaysShowCurrentImage && !isMobile) ||
    (activeIndex === index && isMobile);

  return (
    <div
      className={`c-media-gallery__item ${
        activeIndex === index ? 'active' : ''
      } ${isStanding ? 'standing' : ''}`}
      style={{ width: slideWidth }}
      key={index}
    >
      <span className="show-for-sr">
        {counter} {activeIndex + 1}
      </span>

      <div className="c-media-gallery__item__image">
        <ImageBlockWithSrcSets
          {...props}
          CurrentPageProps={pageProps}
          ImageText={null}
          Modifiers={{ 'c-imageblock--is-gallery': true }}
        />
        <div
          style={{
            visibility: forciblyShowCurrentCount ? 'visible' : 'hidden',
          }}
          className="c-media-gallery__current"
        >
          <span>
            {alwaysShowCurrentImage ? index + 1 : activeIndex + 1}/
            {numberOfItems}
          </span>
        </div>
      </div>
      {(ImageHeading || ImageText || ImageLinks) && (
        <div
          className="c-media-gallery__item__text-container"
          style={{
            visibility:
              !isArticlePage || activeIndex === index ? 'visible' : 'hidden',
          }}
        >
          <div
            className={`c-media-gallery__item__text-wrapper ${
              isArticlePage ? 'article-page' : ''
            }`}
          >
            <MediaGalleryContent
              heading={ImageHeading}
              text={ImageText}
              links={ImageLinks}
              showAuthor={showAuthor}
              photographer={props.Photographer}
              illustrator={props.Illustrator}
              translations={translations}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MediaGalleryImage;
